import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Product.css'; 
import prodictpagelogo from "../assets/images/prodictpagelogo.svg";
import { Productimg } from '../Product list/Productimg'; // ✅ მონაცემების იმპორტი
import LanguageSwitcher from '../LanguageSwitcher';
import Press from './ProductItems/Press/Press';
import Pump from './ProductItems/Pump/Pump';
import Filter from './ProductItems/Filter/Filter';
import Sorter from './ProductItems/Sorter/Sorter';
import Destiller from './ProductItems/Destiller/Destiller';
import GardeningandVineyeard from './ProductItems/GardeningandVineyeard/GardeningandVineyeard';
import Reception from './ProductItems/Reception/Reception';
import DestemmerCrusher from './ProductItems/DestemmerCrusher/DestemmerCrusher';
import FittingsTubes from './ProductItems/FittingsTubes/FittingsTubes';
import BotlingLabeling from './ProductItems/BotlingLabeling/BotlingLabeling';
import FruitEquipment from './ProductItems/FruitEquipment/FruitEquipment';
import SmallEquipments from './ProductItems/SmallEquipments/SmallEquipments';
import WineDispenserComponent from './ProductItems/WineDispenser/WineDispenserComponent';
import CoolingUnit from './ProductItems/CoolingUnit/CoolingUnit';
import TanksBarriquesAnfora from './ProductItems/TanksBarriquesAnfora/TanksBarriquesAnfora';
import UsedEquipments from './ProductItems/UsedEquipments/UsedEquipments';

const componentMap = {
  'Press': Press,
  'Pump': Pump,
  'Filter': Filter,
  'Sorter': Sorter,
  'Destiller': Destiller,
  'Gardening and Vineyard': GardeningandVineyeard,
  'Reception': Reception,
  'Destemmer Crusher': DestemmerCrusher,
  'Fittings Tubes': FittingsTubes,
  'Botling Labeling': BotlingLabeling,
  'Fruit Equipment': FruitEquipment,
  'Small Equipments': SmallEquipments,
  'Wine Dispenser': WineDispenserComponent,
  'Cooler & Heater': CoolingUnit,
  'Tanks Barriques Anfora': TanksBarriquesAnfora,
  'Used Equipments': UsedEquipments,
};

const Product = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { t, i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.product) {
      const product = Productimg.find(p => p.name === location.state.product);
      if (product) {
        setSelectedProduct(product);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }, [location.state]);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const SelectedComponent = selectedProduct ? componentMap[selectedProduct.name] : null;

  return (
    <div className='main-Product'>
      <LanguageSwitcher id="sidebar" />
      <div className='main-Product1'>
        <Link to="/" className='logolink'>
          <img src={prodictpagelogo} alt="Product Page Logo" />
        </Link>  
      </div>

      {SelectedComponent && <SelectedComponent product={selectedProduct} />}

      <div className="Other-products">
        <h1>{t('Other Products')}</h1> 
        <div className="grid-container">
          {Productimg.map((product) => (
            <div key={product.id} className="product-item" onClick={() => handleProductClick(product)}>
              <h1>{t(product.name)}</h1>
              <img src={product.images[i18n.language] || product.images.en} alt={product.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Product;